import { EMerchantType } from '@if/core/types'
import { Box, CircularProgress, Typography } from '@mui/material'
import { useUser } from '@src/contexts/AppContext'
import {
  useGetMerchantLoanActivityMetrics,
  useMerchantById,
  useMerchantByParentId,
} from '@src/data/api/merchants-api/merchants-api'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { MerchantLoanActivityMetricsChart } from './LoanActivityMetrics/MerchantLoanActivityMetricsChart'
import { MerchantLoanActivityMetricsFilterForm } from './LoanActivityMetrics/MerchantLoanActivityMetricsFilterForm'

const Statistics = () => {
  const { t } = useTranslation()
  const currentUser = useUser()

  const [currentMerchant, isMerchantLoading] = useMerchantById(currentUser?.merchantId ?? '')
  const [subsidiaryMerchants, isSubsidiaryLoading] = useMerchantByParentId(
    currentMerchant?.merchantTypeId === EMerchantType.Banner ? (currentMerchant?.id ?? '') : '',
  )

  const [filterParams, setFilterParams] = useState<{ merchantId: string; fromDate: string; toDate: string } | null>(
    null,
  )

  const [merchantLoanActivityMetrics, isLoading] = useGetMerchantLoanActivityMetrics(
    filterParams?.merchantId || '',
    filterParams?.fromDate || '',
    filterParams?.toDate || '',
  )

  const handleFilterSubmit = (merchantId: string, fromDate: string, toDate: string) => {
    setFilterParams({ merchantId, fromDate, toDate })
  }

  if (!currentMerchant || isMerchantLoading || isSubsidiaryLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    )
  }

  return (
    <Box sx={{ width: '100%', p: 3 }}>
      <Typography variant="h4" gutterBottom>
        {t('merchantStatistics.merchantLoanActivity.title')}
      </Typography>

      <MerchantLoanActivityMetricsFilterForm
        currentMerchant={currentMerchant}
        subsidiaryMerchants={subsidiaryMerchants}
        onSubmit={handleFilterSubmit}
      />

      <MerchantLoanActivityMetricsChart
        merchantLoanActivityMetrics={merchantLoanActivityMetrics}
        isLoading={isLoading}
      />
    </Box>
  )
}

export default Statistics
